import React from 'react';
import Sidebar from '../components/widgets/sidebar';
import SidebarType from './sidebar';
import { Route } from 'react-router';
import { TokenVerify } from '../components/interfaces';
import auth from '../utils/auth';

import '../components/app.scss';

const user = auth.getCurrentUser();
class DashboardRouter extends React.Component<any, any> {

  state = {
    userInfo: {
      access: ((user) ? user.access : '')
    } as TokenVerify
  }

  render() {
    return (
      <div className="h-100 d-flex">
        <Sidebar brand="دارستان صنعت">
          <Sidebar.Item path="/dashboard" text="خانه" icon="fal fa-house" />
          {this.renderByAccess(this.state.userInfo.access)}
          <Sidebar.Item path="/logout" text="خروج" icon="fal fa-sign-out" danger={true} />
        </Sidebar>
        <Route {...this.props}></Route>
      </div>
    );
  }

  private renderByAccess = (access: string) => {
    switch (access) {
      case 'admin':
        return <SidebarType.Admin />;
      case 'customer':
        return <SidebarType.Customer />;
      case 'sub-customer':
        return <SidebarType.SubCustomer />;
      default:
        return '';
    }
  }

  componentDidMount = () => {
    const userInfo = auth.getCurrentUser();
    this.setState({ userInfo });
  }


}

export default DashboardRouter;
